
import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { usePermissionContext } from "../../auth/AuthContext";
import { batchDeleteJobs, batchCopyJobs, batchStateChange } from "../../apis/jobApi";
import { Trash, Archive, PlayFill, PauseFill, Play } from "react-bootstrap-icons";

export const BatchJobActions = ({gridRef, setOpen, setGridKey}) =>
{
    const { hasRole } = usePermissionContext();

    const handleBatchDownload = async () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        
    }

    const handleBatchStateChange = async (newJobState) => {
        const selectedRows = gridRef.current.api.getSelectedRows();
      
        const responses = await batchStateChange(newJobState, selectedRows);
        const failedResponses = responses.filter(response => !response.success);
        if(failedResponses.length > 0)
        {
            const failedIds = failedResponses.map(response => response.id).join(", ");
            alert(`Failed to change state for ${failedResponses.length} jobs: ${failedIds}`);
        }
        gridRef.current.api.refreshInfiniteCache();

    }

    return (
        <ButtonGroup>
            <Button className="button-table" variant="primary" disabled={hasRole('Admin')} onClick={() => handleBatchStateChange("start")}><PlayFill/></Button>
            <Button className="button-table" variant="primary" disabled={hasRole('Admin')} onClick={() => handleBatchStateChange("pause")}><PauseFill/></Button>
            <Button className="button-table" variant="primary" disabled={hasRole('Admin')} onClick={() => handleBatchStateChange("archive")}><Archive/></Button>            
            <Button className="button-table" variant="primary" disabled={true} onClick={() => handleBatchStateChange("purge")}><Trash/></Button>            
        </ButtonGroup>
    )
}